import React, { useMemo } from 'react';
import _ from 'lodash';

import styles from './Header.module.scss';
import Icon from '../UI/Icon/Icon';

type HeaderProps = {
  globalState: any;
};

function Header({ globalState }: HeaderProps) {
  const {
    toggleMenu,
    getColorScheme,
    course,
    exitCourse,
    showCloseCourseButton,
  } = globalState;
  const { primary } = getColorScheme();

  const showMenuButton = useMemo(
    () => _.size(course?.pages) > 1,
    [course?.pages]
  );

  return (
    <div className={styles.Header} style={{ backgroundColor: primary }}>
      <div className={styles.Header__left}>
        {showMenuButton ? (
          <Icon
            icon="bars"
            onClick={toggleMenu}
            className={styles.Header__icon}
            testId="menuButton"
          />
        ) : null}
        <div className={styles.Header__title__container}>
          <span className={styles.Header__title}>{course?.name}</span>
        </div>
      </div>
      <div className={styles.Header__right}>
        <div
          className={styles.Header__logo}
          style={{
            backgroundImage: course?.logo?.name
              ? `url('${course.baseURL}/${course?.logo?.name}')`
              : undefined,
          }}
        />
        {showCloseCourseButton && (
          <Icon
            icon="times"
            onClick={exitCourse}
            className={styles.Header__closeIcon}
            testId="close-course-button"
          />
        )}
      </div>
    </div>
  );
}

export default Header;
